import { Injectable } from '@angular/core';

import { OddsBoostToken } from '../../reward-tokens.model';
import { BetBuilderValidator } from './criteria/bet-builder-validator.service';
import { BetslipTypeStateValidator } from './criteria/betslip-type-state-validator.service';
import { CompetitionsValidator } from './criteria/competitions-validator.service';
import { ExpiryDateValidator } from './criteria/expiry-date-validator.service';
import { FixturesValidator } from './criteria/fixtures-validator.service';
import { ForbiddenOddsBoostValidator } from './criteria/forbidden-entities-validator.service';
import { GameTypeValidator } from './criteria/game-type-validator.service';
import { MarketParametersValidator } from './criteria/market-parameters-validator.service';
import { MarketTemplatesValidator } from './criteria/market-templates-validator.service';
import { MarketsValidator } from './criteria/markets-validator.service';
import { MaxOddsValidator } from './criteria/max-odds-validator.service';
import { MaximumStakeValidator } from './criteria/maximum-stake-validator.service';
import { MeetingsValidator } from './criteria/meetings-validator.service';
import { MinimumLegsValidator } from './criteria/minimum-legs-validator.service';
import { MinimumStakeValidator } from './criteria/minimum-stake-validator.service';
import { NotEachWayValidator } from './criteria/not-each-way-validator.service';
import { NotParticipantBetValidator } from './criteria/not-participant-bet-validator.service';
import { OptionValidator } from './criteria/option-validator.service';
import { OverallOddsValidator } from './criteria/overall-odds-validator.service';
import { SelectionLevelMaxOddsValidator } from './criteria/selection-level-max-odds-validator.service';
import { SelectionOddsValidator } from './criteria/selection-odds-validator.service';
import { SlipTypeValidator } from './criteria/slip-type-validator.service';
import { SportsValidator } from './criteria/sports-validator.service';
import { StartDateValidator } from './criteria/start-date-validator.service';
import { TeaserRewardTypeValidator } from './criteria/teaser-reward-type-validator.service';
import { TokenValidator } from './token-validator.service';

@Injectable()
export class OddsBoostTokenValidator extends TokenValidator<OddsBoostToken> {
    constructor(
        startDateValidator: StartDateValidator,
        expiryDateValidator: ExpiryDateValidator,
        sportsValidator: SportsValidator,
        competitionsValidator: CompetitionsValidator,
        meetingsValidator: MeetingsValidator,
        fixturesValiator: FixturesValidator,
        gameTypeValidator: GameTypeValidator,
        slipTypeValidator: SlipTypeValidator,
        minimumLegsValidator: MinimumLegsValidator,
        notParticipantBetValidator: NotParticipantBetValidator,
        forbiddenOddsBoostValidator: ForbiddenOddsBoostValidator,
        maxStakeValidator: MaximumStakeValidator,
        betslipTypeStateValidator: BetslipTypeStateValidator,
        selectionOddsValidator: SelectionOddsValidator,
        overallOddsValidator: OverallOddsValidator,
        betBuilderValidator: BetBuilderValidator,
        teaserRewardTypeValidator: TeaserRewardTypeValidator,
        notEachWayValidator: NotEachWayValidator,
        selectionLevelMaxOddsvalidator: SelectionLevelMaxOddsValidator,
        maxOddsValidator: MaxOddsValidator,
        optionValidator: OptionValidator,
        marketsValidator: MarketsValidator,
        marketTemplatesValidator: MarketTemplatesValidator,
        marketParametersValidator: MarketParametersValidator,
        minimumStakeValidator: MinimumStakeValidator,
    ) {
        super();

        /**
         * BetslipTypeStateValidator ensures 'selectedPicks' is non-empty array;
         * Multiple validators omit check for 0-length and validation will pass on empty picks array.
         */
        this.hardCriteriaValidators.push(betslipTypeStateValidator);
        this.hardCriteriaValidators.push(forbiddenOddsBoostValidator);
        this.hardCriteriaValidators.push(notEachWayValidator);
        this.hardCriteriaValidators.push(notParticipantBetValidator);
        this.hardCriteriaValidators.push(startDateValidator);
        this.hardCriteriaValidators.push(expiryDateValidator);
        this.hardCriteriaValidators.push(sportsValidator);
        this.hardCriteriaValidators.push(competitionsValidator);
        this.hardCriteriaValidators.push(meetingsValidator);
        this.hardCriteriaValidators.push(fixturesValiator);
        this.hardCriteriaValidators.push(gameTypeValidator);
        this.hardCriteriaValidators.push(overallOddsValidator);
        this.hardCriteriaValidators.push(selectionOddsValidator);
        this.hardCriteriaValidators.push(betBuilderValidator);
        this.hardCriteriaValidators.push(slipTypeValidator);
        this.hardCriteriaValidators.push(teaserRewardTypeValidator);
        this.hardCriteriaValidators.push(optionValidator);
        this.hardCriteriaValidators.push(marketsValidator);
        this.hardCriteriaValidators.push(marketTemplatesValidator);
        this.hardCriteriaValidators.push(marketParametersValidator);
        this.softCriteriaValidators.push(minimumLegsValidator);
        this.softCriteriaValidators.push(maxStakeValidator);
        this.softCriteriaValidators.push(overallOddsValidator);
        this.softCriteriaValidators.push(selectionOddsValidator);
        this.softCriteriaValidators.push(minimumStakeValidator);
        this.softCriteriaValidators.push(maxOddsValidator);
        this.softCriteriaValidators.push(selectionLevelMaxOddsvalidator);
    }
}
